import React from "react";
import { Row } from "antd";
import Street from "./Street";
import City from "./City";
import Province from "./Province";
import PostalCode from "./PostalCode";
import Country from "./Country";
import c from "../../utils/common";

const AddressForm = ({ state = {}, readOnly }) => {
  const { data, form, onChange } = state;
  return (
    <Row style={{ marginBottom: "2rem" }}>
      {readOnly ? (
        c.getDisplayAddress(data)
      ) : (
        <>
          <Street
            style={{ width: "100%" }}
            state={{
              data: data?.street,
              form: form,
              rules: [{ required: true, message: "required" }],
              onChange: onChange,
            }}
          />
          <City
            style={{ width: "100%" }}
            state={{
              data: data?.city,
              form: form,
              rules: [{ required: true, message: "required" }],
              onChange: onChange,
            }}
          />
          <Province style={{ width: "100%", marginBottom: "1.5rem" }} />
          <PostalCode
            style={{ width: "100%" }}
            state={{
              data: data?.postalCode,
              form: form,
              rules: [{ required: true, message: "required" }],
              onChange: onChange,
            }}
          />
          <Country style={{ width: "100%" }} />
        </>
      )}
    </Row>
  );
};

export default AddressForm;
